import { Component } from 'react';
import {  
        makeBEM
} from '../global/utils';

import { RevealAnimation } from './Animations';

const wUnitType = "lbs";

class WLogModule extends Component {

    constructor(props) {
        super(props);

        this.state = {
            wLog: this.props.data,
            animate: this.props.animate ? this.props.animate : false
        }

        this.moduleName = 'wlog';
    }

    // Renders a wLog object
    renderContent(wLog) {
        const wValueClass = makeBEM(this.moduleName, `value ${wUnitType}`);
        return (
            <div className={this.moduleName}>
                <h4 className={ makeBEM(this.moduleName, 'value-and-date') }>
                    <span 
                        className={wValueClass}
                    >
                        {wLog.value}
                    </span>
                    <span 
                        className={ makeBEM(this.moduleName, 'date') }
                    >
                        {wLog.getDateCreatedFormattedWithYear()}
                    </span>
                </h4>
            </div>
        )
    }

    render() {
        const wLog = this.state.wLog;
        const animate = this.state.animate;

        return (
            animate ?
            <RevealAnimation>
                {this.renderContent(wLog)}
            </RevealAnimation>
            :
            this.renderContent(wLog)
        );
    }
}

export default WLogModule;